var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"image-wrap"},on:{"touchstart":_vm.touchStartHandler,"mousedown":_vm.mouseDownHandler}},[_c('editor-image-mask'),_c('editor-image-line')],1)}
var staticRenderFns = []

export { render, staticRenderFns }